module.exports = __webpack_public_path__ + "static/media/icon-todo-clock.4867cb2e.svg";